import { Loading } from '@pandiafi/design-system'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import React, { Suspense, useEffect } from 'react'
import { Outlet, ScrollRestoration, useNavigate } from 'react-router-dom'

import { ErrorHandler } from './AuthenticatedErrorHandler'
import { DataLoader } from './AuthenticatedDataLoader'
import { OutletErrorHandler } from './AuthenticatedOutletErrorHandler'

import { Footer, Navbar } from 'components'
import { CloudWatchRumInitializer } from 'components/CloudWatchRumInitializer/CloudWatchRumInitializer'
import { AppVersionBanner } from 'components/AppVersionBanner/AppVersionBanner'
import routePath from 'router/routePath'
import { LoginViewError } from 'views/Login/LoginViewTypes'
import { useAuth } from 'hooks/useAuth/useAuth'

export const AuthenticatedLayout: React.FC = () => {
  const { isAuthenticated } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (!isAuthenticated) {
      navigate(routePath.login, {
        state: LoginViewError.LOGIN_EXPIRED,
      })
    }
  }, [isAuthenticated, navigate])

  return (
    <Suspense fallback={<Loading variant="fullPage" />}>
      <ErrorHandler>
        <DataLoader>
          {({ featureFlags, contacts, contracts, userMetadata }) => (
            <>
              <CloudWatchRumInitializer />
              <AppVersionBanner />
              <Navbar
                featureFlags={featureFlags}
                contracts={contracts}
                userMetadata={userMetadata}
              />
              <main>
                <OutletErrorHandler>
                  <Suspense fallback={<Loading variant="fullPage" />}>
                    <Outlet />
                  </Suspense>
                </OutletErrorHandler>
              </main>
              <Footer layout="authenticated" contacts={contacts} />
              <ScrollRestoration
                getKey={(loc) => {
                  return loc.key
                }}
              />
              <ReactQueryDevtools />
            </>
          )}
        </DataLoader>
      </ErrorHandler>
    </Suspense>
  )
}
